import $ from "jquery";

const uploadPhotoViewer = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            input: ".AccountPage__Wrapper__Contents__EditAccount__Form__Top__Profile .js-UploadPhoto",
            removeButton:
                ".AccountPage__Wrapper__Contents__EditAccount__Form__Top__Profile .js-RemoveUploadPhoto",
            image: ".AccountPage__Wrapper__Contents__EditAccount__Form__Top__Profile #profile-photo-thumbnail",
            imageHeader: ".Header .HeaderDefault__Button--Profile img",
            container:
                ".AccountPage__Wrapper__Contents__EditAccount__Form__Top__Profile",
        };

        if ($(el.container).length === 0) return;

        // show image to viewer
        $(document).on("change", el.input, function () {
            const fileInput = $(this)[0];
            const previewImage = $(el.image)[0];
            const previewImage2 = $(el.imageHeader)[0];

            if (fileInput.files && fileInput.files[0]) {
                const reader = new FileReader();
                $(".loader-image").show(); //show loader

                reader.onload = function (e) {
                    previewImage.src = e.target.result;
                    if ($(el.imageHeader).length > 0) {
                        previewImage2.src = e.target.result;
                    }
                    $(".loader-image").hide(); //hide loader
                    $("#js_deleted_photo").val("false");
                };

                reader.readAsDataURL(fileInput.files[0]);
            } else {
                // Handle the case where the browser doesn't support the File API.
                // eslint-disable-next-line no-console
                console.log("File API not supported in this browser.");
            }
        });

        $(document).on("click", el.removeButton, function () {
            const fileInput = $(this)[0];
            const previewImage = $(el.image)[0];
            const previewImage2 = $(el.imageHeader)[0];

            $("#js_deleted_photo").val("true");

            // The original URL
            const originalURL = window.location.href;

            // Create an anchor element to parse the URL
            const parser = document.createElement("a");
            parser.href = originalURL;

            // Get the base URL
            const baseURL = parser.protocol + "//" + parser.host + "/";

            // Clear the file input and reset the image source
            fileInput.value = "";
            previewImage.src =
                baseURL +
                "wp-content/themes/bijvels-ram/assets/image/utils/placeholder-person.png";
            if ($(el.imageHeader).length > 0) {
                previewImage2.src =
                    baseURL +
                    "wp-content/themes/bijvels-ram/assets/image/utils/placeholder-person.png";
            }
        });
    };

    init();
};

try {
    uploadPhotoViewer();
} catch (error) {
    console.error("uploadPhotoViewer: ", uploadPhotoViewer);
}
